import { atomFactory } from '@utils/recoil/atomFactory';
import { RECOIL_KEYS, RECOIL_PERSIST_KEYS, AGENDA } from '@utils/constants';
import type { UseResponsiveFn } from '@utils/hooks/useResponsive';
import type { AgendaResource } from './resources';

export const { atom: selectedDateState, hook: useSelectedDate } = atomFactory({
    key: RECOIL_KEYS.SELECTED_DATE,
    default: new Date(),
});

export type AgendaCreationContext = {
    start?: Date;
    end?: Date;
    who?: AgendaResource;
};

export const {
    atom: agendaCreationContextState,
    hook: useAgendaCreationContext,
} = atomFactory({
    key: RECOIL_KEYS.AGENDA_CREATION_CONTEXT,
    default: {
        start: undefined,
        end: undefined,
        who: undefined,
    } as AgendaCreationContext,
});

export type AgendaSettings = {
    mobileView: 'day' | 'list' | 'discount';
    desktopView: 'day' | 'threeDay' | 'week';
    filters: 'discount'[];
};

export const {
    atom: agendaSettingsAtom,
    hook: useAgendaSettingsAtom,
} = atomFactory({
    key: RECOIL_KEYS.AGENDA_SETTINGS,
    persistKey: RECOIL_PERSIST_KEYS.AGENDA_SETTINGS,
    default: {
        mobileView: 'day',
        desktopView: 'day',
        filters: [],
    } as AgendaSettings,
});

export type AgendaLayout = {
    columnWidth: number;
} & Partial<ReturnType<UseResponsiveFn>>;

export const {
    atom: agendaLayoutAtom,
    hook: useAgendaLayoutAtom,
} = atomFactory<AgendaLayout>({
    key: RECOIL_KEYS.AGENDA_LAYOUT,
    default: {
        columnWidth:
            (window.innerWidth || 360) / AGENDA.MOBILE_MAX_RESOURCE_ON_SCREEN -
            AGENDA.TIMESCALE_WIDTH_IN_PIXELS /
                AGENDA.MOBILE_MAX_RESOURCE_ON_SCREEN,
    },
});

export const { atom: agendaSyncAtom, hook: useAgendaSyncAtom } = atomFactory({
    key: RECOIL_KEYS.AGENDA_SYNC,
    default: false,
});
